import * as at from './actionTypes';

const INITIAL_STATE = {
	isAuthed: null,
	loading: false,
	user: null,
	error: null
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case at.LOGIN:
			return { ...state, loading: true, error: '' };
		case at.IS_AUTHENTICATED:
			return {
				...state,
				isAuthed: true,
				user: action.payload,
				loading: false
			};
		case at.IS_NOT_AUTHENTICATED:
			return {
				...state,
				isAuthed: false,
				loading: false
			 };
		case at.LOGIN_SUCCESS:
			return {
					...state /* future proofing state */,
					loading: false,
          error: null,
					isAuthed: true
				};
		case at.LOGOUT:
			return { ...state, loading: true }
		case at.LOGIN_FAIL:
			return {
					...state,
					loading: false,
					error: action.payload,
					isAuthed: false
				};
		case at.LOGOUT_SUCCESS:
			return { INITIAL_STATE }
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/services/auth/reducer.js